/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refund_Method_LabelInputs */

const vi_refund_method_label = /** @type {(inputs: Refund_Method_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn bằng`)
};

/**

* @param {Refund_Method_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const refund_method_label = /** @type {((inputs?: Refund_Method_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refund_Method_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_refund_method_label(inputs)
});